import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { isLocalFeatureFlagEnabled, setLocalFeatureFlag } from '@utils/featureFlags';
import { StorageKeys } from '@constants/storageKeys';
import useSentry from '@components/features/sentry/hooks/useSentry';

const useTraceShell = () => {
    const [searchParams] = useSearchParams();
    const isTraceShellEnabled = isLocalFeatureFlagEnabled(StorageKeys.TraceShell);
    const { startSentryReplay, stopSentryReplay } = useSentry();

    const enableTraceShell = () => {
        if (isTraceShellEnabled) return;
        setLocalFeatureFlag(StorageKeys.TraceShell, true);
        window.location.reload();
    };

    const disableTraceShell = () => {
        if (!isTraceShellEnabled) return;
        setLocalFeatureFlag(StorageKeys.TraceShell, false);
        // reload the window without the trace parameter (case insensitive)
        const traceParamKey = Array.from(searchParams.keys()).find((key) => key.toLowerCase() === 'trace');
        if (traceParamKey) searchParams.delete(traceParamKey);
        window.history.replaceState({}, '', `${window.location.pathname}?${searchParams.toString()}`);
        window.location.reload();
    };

    useEffect(() => {
        // Case insensitive check for trace parameter
        const traceValue = Array.from(searchParams.entries())
            .find(([key]) => key.toLowerCase() === 'trace')?.[1]
            ?.toLowerCase();

        if (traceValue === '1' || traceValue === 'true') {
            enableTraceShell();
        }
    }, [searchParams]);

    useEffect(() => {
        if (isTraceShellEnabled) {
            startSentryReplay();
        } else {
            stopSentryReplay();
        }
    }, [isTraceShellEnabled]);

    return {
        enableTraceShell,
        disableTraceShell,
        isTraceShellEnabled,
    };
};

export default useTraceShell;
